// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"9820f701","239":"86c11a1c","453":"3689b230","977":"67cb4c9c"}[chunkId] + ".chunk.js";
};